/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import _ from 'lodash'
import React, { useLayoutEffect, useRef, useState } from 'react'
// import Link from '../link'
import combineClassNames from '../../helpers/combineClassNames'
import IconDropdownArrow from '../../assets/icons/icon_dropdown_arrow.inline.svg'
import useStyles from './collapsible-style'

const CollapsibleView = (props) => {
  const {
    title,
    children,
    defaultOpen = false,
    extraData, // A marker property for telling the list to re-render
    // groupId,
    className,
    titleClassName,
    titleOpenClassName,
    iconClassName,
    iconOpenClassName,
    contentClassName,
    contentInnerClassName,
    contentInnerOpenClassName,
    contentOpenClassName,
  } = props
  const ref = useRef(null)
  const styles = useStyles()

  const [height, setHeight] = useState(0)
  const [open, setOpen] = useState(defaultOpen)

  useLayoutEffect(() => {
    const { height: componentHeight } = ref.current.getBoundingClientRect();
    setHeight(componentHeight);
  }, [open, ..._.castArray(extraData)]);

  return (
    <div
      className={combineClassNames([
        styles.collapsible,
        className,
      ])}
    >
      <div
        className={combineClassNames([
          styles.collapsibleToggle,
        ])}
        onClick={() => setOpen(!open)}
        role="button"
      >
        <span
          className={combineClassNames([
            styles.title,
            titleClassName,
            open && titleOpenClassName,
          ])}
        >
          {title}
        </span>
        <IconDropdownArrow
          className={combineClassNames([
            styles.collapsibleToggleIcon,
            iconClassName,
            open && styles.collapsibleToggleIconOpen,
            open && iconOpenClassName,
          ])}
        />
      </div>
      <div
        className={combineClassNames([
          styles.collapsibleContent,
          contentClassName,
          open && styles.collapsibleContentOpen,
          open && contentOpenClassName,
        ])}
        style={{ maxHeight: open ? height : 0 }}
      >
        <div
          ref={ref}
          className={combineClassNames([
            styles.collapsibleContentInner,
            contentInnerClassName,
            open && contentInnerOpenClassName,
          ])}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export default CollapsibleView
